import { API_HEADERS } from '@trucksmarter/shared';

import env from '~/env.public';

const APP_NAME =
  // Changes the app name if override is set to avoid being blocked by the WAF
  // rules. This is a bit of a hack.
  env.APP_NAME_UNAUTHED_ENDPOINT_OVERRIDE != null
    ? env.APP_NAME_UNAUTHED_ENDPOINT_OVERRIDE
    : 'web-v2';

export const COMMON_REQUEST_HEADERS = {
  [API_HEADERS.appName]: APP_NAME,
  [API_HEADERS.clientCommitSha]:
    env.COMMIT_SHA == null ? 'null' : env.COMMIT_SHA.slice(0, 9),
};
